const state = {
  operateUserName: '', // 修改cinnox配置的用户名(感觉没什么用,后端要求加的0.0)
  user: "wff",
  origin_tree: [],
  version_list:[],
  init_version_name:null,
  operate_list:[]
};
export default state



// WEBPACK FOOTER //
// ./src/store/state.js